var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 681.87 162.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.63,21.64c-9.13,0-16.93,4.38-19.15,12.62l10.02,1.36c1.02-3.04,3.72-5.75,9.13-5.75,5.07,0,7.62,3.27,7.62,6.32s-1.05,3.89-9.41,4.73C10.12,41.79.01,43.38.01,54.88h-.01c0,8.47,6.43,13.43,15.22,13.43,4.4,0,10.14-1.58,13.19-6.99h.34v6.09h10.14v-30.1c0-10.14-6.77-15.66-18.26-15.66ZM28.41,50.54c0,6.37-4.4,10.09-10.48,10.09-3.04,0-7.77-1.35-7.77-6.08,0-5.41,5.75-6.09,11.16-6.77,2.7-.33,5.41-.67,7.1-1.69v4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.2,51.17v-28.74h10.82v26.37c0,7.1,4.06,10.14,8.45,10.14s9.47-3.72,9.47-10.14v-26.37h10.82v44.97h-10.48v-7.78h-.34c-2.37,5.41-7.1,8.79-13.53,8.79-9.47,0-15.22-5.75-15.22-17.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.28,30.54h-6.42v-8.12h6.42v-11.26h10.82v11.26h8.79v8.12h-8.79v23.22c0,4.06,2.03,5.41,4.4,5.41.94,0,2.49-.26,3.4-.55l1.66,8.67c-2.03.68-4.4,1.01-6.42,1.01-7.78,0-13.86-4.73-13.86-12.85v-24.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.62,21.62c-13.53,0-21.64,9.81-21.64,23.33s8.45,23.33,21.64,23.33,21.64-9.8,21.64-23.33-8.45-23.33-21.64-23.33ZM148.62,59.84c-7.44,0-10.82-7.1-10.82-14.88,0-6.76,2.7-14.88,10.82-14.88,7.44,0,10.82,6.77,10.82,14.88s-3.38,14.88-10.82,14.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.16,41.65c8.1,1.76,12.65,5.34,12.65,12.81,0,8.63-9.13,13.83-19.27,13.83s-17.92-4.4-19.27-13.19l10.48-1.01c1.01,4.73,4.06,6.09,8.79,6.09,5.41,0,8.45-2.37,8.45-5.41s-2.72-4.34-6.08-5.07l-7.78-1.69c-7.46-1.62-12.51-5.07-12.51-12.51,0-9.47,8.63-13.86,18.26-13.86s16.57,4.73,17.92,12.51l-9.47,1.01c-1.01-3.38-4.22-5.53-8.44-5.53s-7.78,1.81-7.78,5.19c0,3.04,2.59,4.33,6.28,5.14l7.78,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.07,31.22c-5.75,0-10.14,4.06-10.14,10.14v26.04h-10.82V22.43h10.48v7.44h.34c2.03-5.75,6.76-8.12,11.5-8.12,1.07,0,2.25.09,3.38.33v9.68c-1.16-.29-2.89-.55-4.73-.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.43,21.64c-9.13,0-16.93,4.38-19.14,12.62l10.02,1.36c1.01-3.04,3.72-5.75,9.13-5.75,5.07,0,7.62,3.27,7.62,6.32s-1.05,3.89-9.41,4.73c-8.72.88-18.83,2.47-18.83,13.97h0c0,8.47,6.42,13.43,15.21,13.43,4.4,0,10.14-1.58,13.19-6.99h.34v6.09h10.14v-30.1c0-10.14-7.44-15.66-18.26-15.66ZM311.22,50.53c0,6.37-4.4,10.09-10.48,10.09-3.04,0-7.77-1.35-7.77-6.08,0-5.41,5.75-6.09,11.16-6.76,2.7-.34,5.41-.68,7.1-1.69v4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.3,11.17v18.58h-.67c-2.47-5.28-6.92-8.04-12.84-8.11-11.02.07-18.47,9.44-18.6,23.33.13,12.59,6.77,23.16,18.6,23.33,6.09-.17,10.76-3.6,12.84-8.11h.67v7.22h10.48V11.17h-10.48ZM350.82,59.5c-7.13-.08-10.69-6.63-10.82-14.54.13-8.74,3.69-14.53,10.82-14.53,7.49,0,10.6,6.38,10.48,14.53.12,7.63-3.15,14.46-10.48,14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.49,59.83c-7.19.11-11.52-4.99-11.5-12.17h31.11v-3.04c-.01-14.25-7.41-22.92-20.29-22.99-13.46.07-21.45,9.58-21.3,23.33-.15,14.26,8.23,23.25,21.64,23.33,7.48-.08,17.37-3.43,19.61-13.18l-9.81-1.02c-1.64,4.37-5.73,5.86-9.46,5.75ZM401.1,30.09c6.05-.11,10.22,4.75,10.14,10.48h-20.96c.19-4.85,3.76-10.58,10.82-10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.63,30.54h-6.42v-8.12h6.42v-11.26h10.82v11.26h8.79v8.12h-8.79v23.22c0,4.06,2.03,5.41,4.4,5.41.94,0,2.49-.26,3.4-.55l1.66,8.67c-2.03.68-4.4,1.01-6.42,1.01-7.78,0-13.86-4.73-13.86-12.85v-24.92Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.82,78.09h-16.73v-27.89c0-27.73-22.48-50.2-50.2-50.2s-50.2,22.48-50.2,50.2v27.89h-44.62v22.31h44.62v44.62h22.31v-44.62h55.78v16.73c0,21.56,17.48,39.05,39.05,39.05s39.05-17.48,39.05-39.05-17.48-39.05-39.05-39.05ZM548,78.09v-28.45c0-15.41,12.49-27.89,27.89-27.89s27.89,12.48,27.89,27.89v28.45h-55.78ZM642.82,133.87c-9.24,0-16.73-7.49-16.73-16.73v-16.73h16.73c9.24,0,16.73,7.49,16.73,16.73s-7.49,16.73-16.73,16.73Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 352,
    y: 86.91,
    width: 16.65,
    height: 13.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.32,98.14c-5.94,0-10.94,3.28-13.02,8.69h-.36v-8.09H1.41v63.7h16.65v-24.97h.24c2.1,5.14,7.22,8.27,12.91,8.27,11.35,0,18.21-9.66,18.21-23.83s-6.38-23.76-18.1-23.76ZM32.13,122c0,6.07-2.18,10.97-7.23,10.97s-7.37-5.2-7.37-10.98c0-6.25,2.34-10.97,7.37-10.97s7.23,5,7.23,10.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.78,125.76v-3.86c0-14.32-8.85-23.76-23.04-23.76-13.24,0-23.52,8.56-23.52,23.88,0,13.76,8.09,23.71,23.88,23.71,10.08,0,20.81-4.07,22.68-15.63h-15.19c-.99,2.63-4,4.1-7.12,4.1-4.75,0-7.84-3.07-7.84-7.72v-.72h30.16ZM70.62,116.56c.13-4.11,3.66-6.75,7.47-6.75,4.11,0,7.29,2.75,7.35,6.75h-14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.07,112.71c-2-.42-3.72-.6-5.49-.6-4.74,0-9.22,2.19-9.22,9.34v23.57h-16.65v-46.29h16.17v8.81h.48c1.33-5.87,5.24-9.41,10.57-9.41,1.3,0,2.69.2,4.14.64v13.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.53,144.28c-3.74.92-7.28,1.43-10.46,1.43-8.9,0-14.99-3.99-14.99-13.97v-19.27h-5.91v-12.06h5.91v-13.49h16.65v13.49h7.96v12.06h-7.95v17.7c0,2.2,1.38,2.88,3.2,2.88.98,0,2.03-.12,3.19-.44l2.41,11.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.37,98.12c-11.48,0-20.49,5.38-21.22,15.69h15.32c.43-3.13,2.76-4.22,5.66-4.22,2.74,0,4.95,1.22,4.95,3.74,0,2.26-1.69,3.35-7.2,3.87-13.26,1.27-20.54,4.48-20.54,15.06,0,8.92,6.06,13.46,15.07,13.46,5.96,0,10.62-1.99,13.4-7.19h.36v6.51h15.56v-29.81c0-10.65-6.49-17.1-21.35-17.1ZM403.18,128.76c0,4.06-3.44,6.63-7.35,6.63-2.45,0-4.83-1.17-4.83-3.98,0-3.85,3.64-4.49,7.22-5.11,1.84-.32,3.66-.64,4.96-1.39v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.89,98.12c-11.48,0-20.49,5.38-21.22,15.69h15.32c.43-3.13,2.76-4.22,5.66-4.22,2.74,0,4.95,1.22,4.95,3.74,0,2.26-1.69,3.35-7.2,3.87-13.26,1.27-20.54,4.48-20.54,15.06,0,8.92,6.06,13.46,15.07,13.46,5.96,0,10.62-1.99,13.4-7.19h.36v6.51h15.56v-29.81c0-10.65-6.49-17.1-21.35-17.1ZM300.69,128.76c0,4.06-3.44,6.63-7.35,6.63-2.45,0-4.83-1.17-4.83-3.98,0-3.85,3.64-4.49,7.22-5.11,1.84-.32,3.66-.64,4.96-1.39v3.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 162.18,
    y: 86.91,
    width: 16.65,
    height: 58.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.21,
    y: 86.91,
    width: 16.65,
    height: 58.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.3,
    y: 86.91,
    width: 16.65,
    height: 58.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 352.01,
    y: 105.47,
    width: 16.65,
    height: 39.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "184.69 105.47 196.78 105.47 204.38 86.91 188.18 86.91 184.69 105.47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.c2ae53f0ef568d4329ad468060aad326.svg";
export { ForwardRef as ReactComponent };